
import { ContactUs, Home, MedevacServices, MedicalLogisticalServices, MedicalStaffingSolutions, OccupationalHealthServices, TelemedicineServices } from './pages';

export const routes = [
    { title: 'Home', path: '/', element: Home },
    { title: 'Medical Staffing Solutions', path: '/medical-staffing-solutions', element: MedicalStaffingSolutions },
    { title: 'Telemedicine Services', path: '/telemedicine-services', element: TelemedicineServices },
    { title: 'MEDEVAC Services', path: 'medevac-services', element: MedevacServices },
    { title: 'Occupational Health Services', path: '/occupational-health-services', element: OccupationalHealthServices },
    { title: 'Medical Logistical Services', path: '/medical-logistical-services', element: MedicalLogisticalServices },
    { title: 'Contact Us', path: '/contact-us', element: ContactUs },
]
